import { Component, OnInit, Input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';


@Component({
  selector: 'app-exchangerate',
  templateUrl: './exchangerate.component.html',
  styleUrls: ['./exchangerate.component.scss']
})
export class ExchangerateComponent implements OnInit {

  @Input() data;
  legalCurrency;
  telecomunicationTotal;
  taxTotal;
  telecomunicationTotalName;
  taxTotalName;
  exchangeRateName;
  exchangeRateValue;

  constructor(private cp: CurrencyPipe) { }

  ngOnInit() {
    this.telecomunicationTotalName = this.data.exchangeRateInfo[0].name;
    this.telecomunicationTotal = this.data.exchangeRateInfo[0].value;
    this.taxTotal = this.data.exchangeRateInfo[1].value;
    this.taxTotalName = this.data.exchangeRateInfo[1].name;
    this.legalCurrency = this.data.legalEntityCurrency;
    this.exchangeRateName = this.data.exchangeRateInfo[2].name;
    this.exchangeRateValue = this.data.exchangeRateInfo[2].value;
  }
}
